import { NavLink, useParams } from 'react-router-dom';
import useGallery from './hooks/useGallery';
import useQueryString from '../../Common/components/hooks/useQueryString';
import { createGlobalStyle } from 'styled-components';
import { useEffect, useState } from 'react';
import Loading from '../../Common/components/Loading';
import GalleryImage from './GalleryImage';
import './Gallery.css';
import logo from '../../smile_icon.png';
import DownloadButton from '../../Share/components/DownloadButton';

interface DefaultThemeProps {
    foregroundColor?: string;
    backgroundColor?: string;
    headerBackgroundColor?: string;
    headerForegroundColor?: string;
}

const GlobalStyle = createGlobalStyle`
body {
        color: ${({ foregroundColor }: DefaultThemeProps) =>
            foregroundColor || '#000'};
        background-color: ${({ backgroundColor }: DefaultThemeProps) =>
            backgroundColor || '#FFF'};;
}

.Fullscreen-modal {
    color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || '#000'};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};;

}

.Share-form input {
    color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || '#000'};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};
    border-color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || '#000'};
    border-style:solid;
    font-family: 'Roboto', sans-serif;
}

.Share-form .Link-button {
    background-color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || '#000'};
    color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};;
}

.SB-Modal {
    color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || '#000'};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};;
}

.Gallery-cell.expanded {
color: ${({ foregroundColor }: DefaultThemeProps) => foregroundColor || '#000'};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};;
}

.Gallery-cell.expanded > .options {
color: ${({ foregroundColor }: DefaultThemeProps) => foregroundColor || '#000'};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};;
}

.cta-button {
    background-color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || '#000'};
    color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};
    }

.Gallery-header {
    background-color: ${({ headerBackgroundColor }: DefaultThemeProps) =>
        headerBackgroundColor || '#000'};
    color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || '#FFF'};
}

.Gallery-name {
    color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || '#FFF'};
}

.Find-your-own-photos-banner {
    background-color: ${({ headerBackgroundColor }: DefaultThemeProps) =>
        headerBackgroundColor || '#000'};
    color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || '#FFF'};
}

.Media-container {
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'}; 
}

.video-js {
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'} !important; 
}

`;

export default function GalleryPhoto() {
    const [isLoading, setIsLoading] = useState(true);
    const [galleryInfo, setGalleryInfo] = useState<GalleryObject | null>(null);
    const query = useQueryString();
    const { galleryId } = useParams();
    const [media, setMedia] = useState<MediaInstance | null>(null);

    const shareIdentifier = query.get('si');

    const { getPhotoByShareIdentifier, getGalleryById } = useGallery({
        galleryId: galleryId ? +galleryId : 0,
        slug: '',
    });

    useEffect(() => {
        let isMounted = true;

        const getPhoto = async () => {
            if (!shareIdentifier) {
                return;
            }

            try {
                const mediaResponse = await getPhotoByShareIdentifier(
                    shareIdentifier,
                );

                console.log('Media Response: ', mediaResponse);

                const galleryResponse = await getGalleryById();

                isMounted && setMedia(mediaResponse);
                isMounted && setGalleryInfo(galleryResponse);
            } catch (e) {
                console.error(e);
            } finally {
                isMounted && setIsLoading(false);
            }
        };

        getPhoto();

        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const hasCTA = galleryInfo?.ctaImage || galleryInfo?.ctaText;
    const showGalleryLink = galleryInfo?.showGalleryLink;

    return (
        <div>
            <GlobalStyle
                foregroundColor={galleryInfo?.foregroundColor}
                backgroundColor={galleryInfo?.backgroundColor}
                headerBackgroundColor={galleryInfo?.headerBackgroundColor}
                headerForegroundColor={galleryInfo?.headerForegroundColor}
            />
            <Loading isLoading={isLoading} />
            {!isLoading && (
                <div className={`Gallery-header`}>
                    <div className="Gallery-header-title">
                        <img
                            src={galleryInfo?.logo || logo}
                            alt="Smilebooth Logo"
                        />
                    </div>
                    <div className="Gallery-name">{galleryInfo?.name}</div>
                </div>
            )}
            <div className="Gallery-photo-container">
                {media ? (
                    <>
                        <div className="spacer" />
                        <div className="spacer" />
                        <div className="media">
                            <GalleryImage
                                media={media}
                                galleryId={galleryId ? +galleryId : 0}
                            />
                        </div>
                        <div className="spacer" />
                        <div className="spacer" />
                    </>
                ) : null}
            </div>
            <br />
            <br />
            <div className="Gallery-navigation">
                {media ? (
                    <div className="Photo-buttons">
                        <DownloadButton
                            uri={media?.originalUri}
                            mimeType={media?.mimeType}
                            mediaId={media?.id}
                            source="gallery"
                        />
                    </div>
                ) : null}
                {hasCTA ? (
                    <div
                        className="Gallery-cta"
                        onClick={() => {
                            if (galleryInfo?.ctaLink) {
                                window.open(galleryInfo?.ctaLink, '_blank');
                            }
                        }}
                    >
                        {galleryInfo?.ctaImage && (
                            <img
                                src={galleryInfo?.ctaImage}
                                alt="Smilebooth CTA"
                            />
                        )}
                        {galleryInfo?.ctaText && <p>{galleryInfo?.ctaText}</p>}
                    </div>
                ) : null}
                <div className="spacer" />
                {showGalleryLink && (
                    <div className="Photo-buttons">
                        <NavLink
                            to={`/gallery/${galleryId}`}
                            className="cta-button"
                        >
                            Back To Gallery
                        </NavLink>
                        <div className="spacer" />
                    </div>
                )}
                <div className="spacer" />
            </div>
        </div>
    );
}
